import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  unit: null,
  units: []
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
